// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskTime {
  private maxLength = 4;

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > 20) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }
    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      const formatedValue = value.replace(/^(\d{2})(\d{1})(\d{1})*/, '$1:$2$3');
      let formatedCursorPosition = cursorPosition;
      if (cursorPosition >= 3) formatedCursorPosition++;

      return { formatedValue, formatedCursorPosition: formatedCursorPosition };
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    if (value.match(/^(([0-1][0-9])|(2[0-3])):?[0-5][0-9]$/) && value.replace(':', '').length === 4)
      return true;
    return false;
  }

  public getMaskErrors() {
    return ['TIME'];
  }
}
